import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const ALIMTALK_MENU: PermissionTableRowType = {
  name: '알림톡 발송',
  key: 'ALIMTALK_MANAGE',
  subRows: [
    {
      name: '발송 스케줄',
      key: PERMISSION_SUBJECTS.ALIMTALK_SEND_SCHEDULE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '발송 이력 조회',
          key: PERMISSION_SUBJECTS.ALIMTALK_SEND_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '발송 상세/발송 미리보기',
          key: PERMISSION_SUBJECTS.ALIMTALK_SEND_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '발송 등록/테스트 발송/CSV 업로드',
          key: PERMISSION_SUBJECTS.ALIMTALK_SEND_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '예약 취소',
          key: PERMISSION_SUBJECTS.ALIMTALK_SEND_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      name: '발송 템플릿',
      key: PERMISSION_SUBJECTS.ALIMTALK_TEMPLATE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '템플릿 목록 조회',
          key: PERMISSION_SUBJECTS.ALIMTALK_TEMPLATE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '템플릿 상세/샘플 CSV',
          key: PERMISSION_SUBJECTS.ALIMTALK_TEMPLATE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '템플릿 등록',
          key: PERMISSION_SUBJECTS.ALIMTALK_TEMPLATE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '템플릿 수정/비활성화',
          key: PERMISSION_SUBJECTS.ALIMTALK_TEMPLATE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
